import { render, staticRenderFns } from "./tickerMessage.vue?vue&type=template&id=720111c2&"
import script from "./tickerMessage.vue?vue&type=script&lang=js&"
export * from "./tickerMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports